<!--
 * @Author: DY
 * @Date: 2025-02-17 16:49:33
 * @LastEditTime: 2025-02-24 16:53:03
 * @Description: 鳞片石墨价格查询表单【销售管理-鳞片石墨价格查询】
 * @FilePath: \ShiMo_Mobile\src\views\sales\flakeGraphitePriceInquiry\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="flakeGraphitePriceInquiryForm commonFormStyles">
            <HeaderNav
                header-title="鳞片石墨价格表单"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <van-tabs class="currencyTabsStyle" v-model="tabActive">
                <van-tab title="基本信息" name="1">
                    <ul class="formList" :class="{'formList_Readonly' : isReadonly}">
                        <li>
                            <van-field
                                disabled
                                label="生效日期"
                                :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                v-model="formData.EffectiveDate"
                            ></van-field>
                        </li>
                        <li>
                            <van-field
                                disabled
                                label="截止日期"
                                :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                v-model="formData.CutoffDate"
                            ></van-field>
                        </li>
                        <li>
                            <van-field
                                disabled
                                label="创建人"
                                :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                v-model="formData.CreatorName"
                            ></van-field>
                        </li>
                        <li>
                            <van-field
                                disabled
                                label="创建时间"
                                :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                v-model="formData.CreationTime"
                            ></van-field>
                        </li>
                        <li>
                            <van-field
                                disabled
                                label="发布时间"
                                :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                v-model="formData.PublishTime"
                            ></van-field>
                        </li>
                    </ul>
                </van-tab>
                <van-tab title="价格明细" name="2">
                    <van-form validate-first class="form_">
                        <div class="info_box">
                            <div class="items" v-if="formData.MaterialList.length > 0">
                                <div class="list_item" v-for="(item, index) in formData.MaterialList" :key="index">
                                    <p class="title">
                                        <span>
                                            <span>物料代码：{{ item.MaterialCode }}</span>
                                        </span>
                                    </p>
                                    <div class="ps_box">
                                        <div class="list_item_card">
                                            <van-field
                                                label="短描述"
                                                :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                                input-align="right"
                                                placeholder=""
                                                v-model="item.MaterialShortName"
                                                readonly
                                            ></van-field>
                                            <van-field
                                                label="单位"
                                                :left-icon="require('@/assets/images/icons/icon_2@2x.png')"
                                                input-align="right"
                                                placeholder=""
                                                v-model="item.MaterialUnit"
                                                readonly
                                            ></van-field>
                                        </div>
                                        <div class="priceList">
                                            <div class="priceItem" v-for="(k, j) in item.PriceList" :key="`wljg_${j}`">
                                                <div>
                                                    <h5>产品基础价格(元/吨)：</h5>
                                                    <van-field v-model="k.PriceBase" label-align="right" disabled></van-field>
                                                </div>
                                                <div>
                                                    <h5>优惠数量基数最小值(含)：</h5>
                                                    <van-field v-model="k.DiscountMin" label-align="right" disabled></van-field>
                                                </div>
                                                <div>
                                                    <h5>优惠数量基数最大值(不含)：</h5>
                                                    <van-field v-model="k.DiscountMax" label-align="right" disabled></van-field>
                                                </div>
                                                <div>
                                                    <h5>备注说明：</h5>
                                                    <van-field
                                                        disabled
                                                        label="备注"
                                                        type="textarea"
                                                        v-model="k.Remarks"
                                                        :rows="2"
                                                    ></van-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-form>
                </van-tab>
            </van-tabs>
            <footer class="currencyFooterStyle btns">
                <van-button type="primary" loading-type="spinner" @click="closeAllocationForm">
                    关闭
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    // 库位表单
    name: 'flake-graphite-price-inquiry-form',
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            tabActive: 0,
            isReadonly: false,
            formData: {
                MaterialList: [],
            },
        };
    },
    computed: {},
    watch: {},
    activated() {},
    async created() {
        this.formData = await this.getformDataRequrst(this.$route.params.id);
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'flakeGraphitePriceInquiry',
            });
        },
        getformDataRequrst(id) {
            return this.$axios.$get(`/interfaceApi/sale/config_price/info/${id}`);
        },
    },
};
</script>
<style lang="stylus">
.flakeGraphitePriceInquiryForm
    background: #f0f0f0;
    .currencyTabsStyle
        height 0
        flex 1
    .info_box
        border-radius 4rpx
        background: #fff;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
    .formList
        &.formList_Readonly
            height calc(100% - 44rpx)
    .items
        padding 10rpx
        height calc(100% - 40rpx)
        overflow-y: auto;
    .van-cell__right-icon
        color #666
    .list_item
        overflow hidden
        background #fff
        box-shadow: 0px 0px 3px 0px #b5b5b5;
        border-radius: 4rpx;
        position relative
        margin-bottom 10rpx
        &:last-child
            margin-bottom 0
        .title
            width 100%
            height 42rpx
            background #F8F8F8
            margin-bottom 0 !important
            display flex
            align-items center
            padding 0 10rpx
            font-size 16rpx
            position relative
            display: flex;
            justify-content: space-between;
            >span
                color: #e93743
                display: flex;
                justify-content: center;
                align-items: center;
            .btn
                position absolute
                top 0
                right 0
                color #fff !important
                font-size 13rpx !important
                background: #f86565;
                padding 2rpx 5rpx
                border-radius: 0 8rpx
                font-weight: 500 !important;
                &.btn_ok
                    background #ccc !important
    .ps_box
        display: flex
        flex-wrap: wrap;
        .van-cell
            display: flex;
            align-items: center;
        .list_item_card
            width 100%
        .priceList
            width 100%
            margin 0 8rpx 8rpx
            .priceItem
                width 100%
                padding 8rpx
                background: #FFFFFF;
                box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
                border-radius: 4px;
                border: 1px solid #E7E6E6;
                margin-bottom: 8rpx
                &:last-child
                    margin-bottom 10rpx
                h5
                    font-size 12rpx
                    color #626262
                    margin 10rpx 0 5rpx 0
                .van-cell__title
                    display none
                .van-cell
                    padding: 5px 8px;
                    border: 1px solid #ADC7E0;
                    background #FAFBFE
                    border-radius 4px
                    &.van-field--disabled
                        background: #f8f8f8;
                        border-color: #d7d7d7;
                        color: rgba(98, 98, 98, 0.7);
                    input
                        width 100%
</style>
